import './toolbar.css';
/* Assets */
import Shaia from '../../assets/new_shaia.png'; 

// Toolbar
const Toolbar = ({children}) => (
  <div className="toolbar">
    <div className='toolbar-shaia'><img src={Shaia} alt='Shaia' /></div>
    {children}
  </div>
);

export default Toolbar;
